const NOT_FOUND_MESSAGE = { reason: "Resource Not Found" } as const;

/** Core `NOT_FOUND` for airplane lookups (e.g. airplanesActiveController). */
const AIRPLANE_NOT_FOUND_REASON = "Airplane was not found" as const;

/** Core `NOT_AUTHORIZED` when the plane exists but not for this linked account. */
const AIRPLANE_ACCESS_UNAUTHORIZED_REASON =
  "You are not authorized to access this airplane" as const;

/** Core login `NOT_FOUND` when credentials do not match an active user. */
const LOGIN_INVALID_CREDENTIALS_REASON =
  "Username Or Password is invalid" as const;

/** Core `NOT_FOUND` when an organization has no self-registration access code. */
const ORGANIZATION_ACCESS_CODE_NOT_FOUND_REASON =
  "No registration code exists for this organization" as const;

export {
  AIRPLANE_ACCESS_UNAUTHORIZED_REASON,
  AIRPLANE_NOT_FOUND_REASON,
  LOGIN_INVALID_CREDENTIALS_REASON,
  NOT_FOUND_MESSAGE,
  ORGANIZATION_ACCESS_CODE_NOT_FOUND_REASON,
};
